<template>
    <li class="condition">
        <div class="line">
            <div>Condition n°{{k+1}} :
                <model-list-select v-model="condition.question"
                                   :list="otherQuestions"
                                   option-value="id"
                                   option-text="label"
                                   placeholder="Sélectionner une question">

                </model-list-select>
            </div>
            <btn ico="delete" color="red" @click="remove"></btn>
        </div>
        <div class="line" v-if="!isCheckbox()">
            <div>
                <select v-model="condition.responses.equal">
                    <option value="equal">Egale</option>
                    <option value="contain">Contient</option>
                    <option value="not-equal">Différent</option>
                    <option value="not-contain">Ne contient pas</option>
                </select>
            </div>
            <div>
                <input type="text" placeholder="Valeur" v-model="condition.responses.value">
            </div>
        </div>
        <div v-else>
            <div class="line">
                <div style="width:200px">
                    <select v-model="condition.responses.equal">
                        <option value="equal">Egale</option>
                        <option value="not-equal">Différent</option>
                    </select>
                </div>
                <model-list-select v-model="condition.responses.value"
                                   :list="questionContent"
                                   option-value="value"
                                   option-text="value"
                                   placeholder="Sélectionner une réponse">

                </model-list-select>
            </div>
        </div>
    </li>
</template>

<script>
    import Btn from "@/components/Btn";
    import {ModelListSelect} from 'vue-search-select';

    export default {
        name: "Condition",
        components: {Btn, ModelListSelect},
        props: {
            k: 0,
            condition: {},
            questionId:0,
        },
        methods: {
            remove() {
                this.$emit("remove", this.k)
            },
            getCurrentQuestion(){
                // return this.$store.getters.getCurrentQuestions.find((question) => this.condition.question === question.id);
                for(let i =0; i< this.$store.getters.getCurrentQuestions.length; i++){
                    if(this.$store.getters.getCurrentQuestions[i].id === this.condition.question){
                        return this.$store.getters.getCurrentQuestions[i]
                    }
                }
                return {};
            },
            isCheckbox(){
                return this.questionType === 'checkbox' || this.questionType === 'radio' || this.questionType === 'select'
            }
        },
        computed: {
            questionType(){
                return this.getCurrentQuestion().type;
            },
            questionContent(){
                return this.getCurrentQuestion().content;
            },
            otherQuestions(){

                let questions = JSON.parse(JSON.stringify(this.$store.getters.getCurrentQuestions));

                questions.map((question,k) => {

                    question.label = 'Question '+(k+1) +' : '+ (question.labelText || question.label);

                    if(question.label.length > 70){
                        question.label = question.label.substr(0,67)+"..."
                    }

                    return question;
                });

                return questions.filter((question) => question.id !== this.questionId && question.type !== 'none')
            }
        },
    }
</script>